import React from 'react'
import styled from 'styled-components'
import urlTo from '../functions/url.mjs'

const UnstyledBackgroundImage = ({
  className,
  image,
  alt,
  url
}) => { 
  const props = {}
  const imageSrc = image ? (image.src || image.url || image.file?.url) : null
 
  props.className = className

  if (image && !image.file) {
    console.log('no image file')
    console.log(image)
    return
  }
  props.srcSet = image ? image.file.srcset : null 
  props.src = imageSrc || url
  props.title = image ? image.title : urlTo(props.src,'fileName')
  props.alt = image ? image.alt : props.title

  return <img {...props}/>
}

const BackgroundImage = styled(UnstyledBackgroundImage)`
  position: absolute !important;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  object-fit: cover;
  width: 100%;
  height: 100%;
  // filter: ${props => props.filter === 'dark' ? `brightness(.62)` : null};
`

export default BackgroundImage